import React, { useContext } from 'react';
import { DesktopIcon, MenuIcon, PhoneIcon } from '@paypalcorp/pp-react-icons';
import { Switch } from '@paypalcorp/pp-react-switch';
import { BodyText } from '@paypalcorp/pp-react-text';
import { CustomColumn, CustomRow, SelectIconButton } from '@MerchantConfigurator/components/common';
import {
  Colors,
  elementIDs,
  EventCounters,
  MessagingContent,
  PreviewModes,
  Sizes
} from '@MerchantConfigurator/constants';
import { ApplicationContext } from '@MerchantConfigurator/context';
import PropTypes from 'prop-types';
import styles from './PreviewControls.module.less';
import { trackButtonClick, trackButtonChange } from '../../../../../lib/fpti';

const PreviewControls = ({
  darkMode,
  previewMode,
  setDarkMode,
  setPreviewMode,
  updateCounters
}) => {
  const { content, styleOverrides } = useContext(ApplicationContext);

  return (
    <CustomRow
      justifyContent="flex-end"
      height={Sizes['xl']}
      width={`calc(100% - 40px)`}
      gap={'5px'}
      borderBottom={'1px solid #ffffff'}
      padding={'10.5px 0'}
    >
      <CustomRow justifyContent="flex-tart" width="auto">
        <BodyText
          className={styles.preview_controls_text}
          id={elementIDs.previewSectionSubHeaderText}
        >
          {content[MessagingContent.preview]}:
        </BodyText>
        <SelectIconButton
          style={{
            borderRadius: '3px',
            backgroundColor:
              previewMode === PreviewModes.desktop ? Colors.MOSTLYPUREBLUE : 'transparent'
          }}
          selected={previewMode === PreviewModes.desktop}
          onClick={() => {
            setPreviewMode(PreviewModes.desktop);
            updateCounters(EventCounters.desktopPreviewClicked);
            trackButtonClick('Preview: Desktop');
          }}
        >
          <DesktopIcon size="sm" color="sysColorBackgroundSurface" />
        </SelectIconButton>
        <SelectIconButton
          style={{
            borderRadius: '3px',
            backgroundColor:
              previewMode === PreviewModes.desktop ? 'transparent' : Colors.MOSTLYPUREBLUE
          }}
          selected={previewMode === PreviewModes.mobile}
          onClick={() => {
            setPreviewMode(PreviewModes.mobile);
            updateCounters(EventCounters.mobilePreviewClicked);
            trackButtonClick('Preview: Mobile');
          }}
        >
          <PhoneIcon size="sm" color="sysColorBackgroundSurface" />
        </SelectIconButton>
      </CustomRow>
      <CustomColumn>
        <CustomRow>
          <BodyText className={styles.preview_controls_text}>
            {content[MessagingContent.darkMode]}:
          </BodyText>
          <Switch
            checked={darkMode}
            className={styleOverrides?.toggle}
            description=""
            id={elementIDs.previewSectionDarkModeToggle}
            inline
            label={''}
            css={{ paddingRight: Sizes.lg }}
            onChange={() => {
              setDarkMode(!darkMode);
              updateCounters(EventCounters.previewColorClicked);
              darkMode
                ? trackButtonChange('Dark Mode', false)
                : trackButtonChange('Dark Mode', true);
            }}
          />
        </CustomRow>
      </CustomColumn>
    </CustomRow>
  );
};

export default PreviewControls;

PreviewControls.propTypes = {
  darkMode: PropTypes.bool,
  previewMode: PropTypes.string,
  setDarkMode: PropTypes.func,
  setPreviewMode: PropTypes.func,
  updateCounters: PropTypes.func
};
